import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { useHistory } from "react-router-dom";

import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { showMessage } from "utils/messages";
import { cpfUnmask, phoneMask } from "utils/mask";
import {
  resetLoading,
  setLoading,
  setTitleLoading,
} from "redux/ui/loadings-slice";
import { addNegotiatePage } from "redux/features/security/security-slice";

const Negocie: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const { negotiatePage } = useAppSelector((state) => state.security);

  useEffect(() => {
    if (!negotiatePage) {
      history.push(RouteNames.HOME);
    }
  }, [history, negotiatePage]);

  const {
    cliente: { cpf, email, celular, nome },
  } = useAppSelector((state) => state.cliente);

  const phoneNumber = phoneMask(celular).masked;

  const firstName = nome?.split(" ")[0];
  const clickToBack = () => {
    showMessage(
      "warning",
      "IMPORTANTE!",
      "Pedimos que entre em contato conosco através do nr. 4003-3203 ou pelo WhatsApp (92) 4003-3203. Grato!",
      { timer: 15000, showConfirmButton: true }
    );
    dispatch(addNegotiatePage(false));
  };

  const RequestSmsEmail = useApi<any>(
    Endpoints.usuario.smsClienteNegociacao,
    ApiMethod.POST
  );

  const sendSmsEmail = async () => {
    if (!negotiatePage) return;

    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando aguarde..."));
    dispatch(addNegotiatePage(false));

    try {
      const payload = {
        cpf: cpfUnmask(cpf),
        decisao: true,
        email: email,
      };

      const response = await RequestSmsEmail.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        showMessage(
          "success",
          "Ótimo!",
          `Enviamos uma proposta por SMS para o Nº ${
            phoneNumber.substring(0, phoneNumber.length - 5) + "****"
          } e para o endereço 
          de e-mail: ${email?.replace(
            /^(.{2}).+(?=@)/,
            "$1****"
          )}. Vamos continuar por lá. Obrigado!`,
          { timer: 15000, showConfirmButton: true }
        );
      } else {
        const { mensagem } = response.data;

        showMessage(
          "error",
          "Atenção!",
          mensagem ||
            "Não foi possível enviar tua solicitação, tente novamente mais tarde!",
          { timer: 10000, showConfirmButton: true }
        );
      }
    } catch (error) {
      showMessage(
        "error",
        "Atenção!",
        "Não foi possível enviar tua solicitação, tente novamente mais tarde!",
        { timer: 10000, showConfirmButton: true }
      );
    } finally {
      history.push(RouteNames.HOME);
    }
    dispatch(resetLoading());
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Negocie</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>
            Sr.(a) {firstName}, temos uma excelente proposta para regularizar
            seus débitos em atraso, deseja receber via SMS a proposta de
            negociação?
          </span>
        </St.Description>
      </ContainerFlex>
      <br />
      <br />
      <ContainerFlex center row horizontal space width={50}>
        <AppButton content="Não" outlined click={clickToBack} />
        <AppButton content="Sim" click={sendSmsEmail} />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default Negocie;
